import type { MoodCheckMode, WotSelection } from '@/store/sessionTypes'

export type SessionStartStep =
  | 'checkin'
  | 'benchmark-intro'
  | 'panas'
  | 'menu'
  | 'landing'

export interface SessionStartOptions {
  includeWotCheck: boolean
  includeWarmup: boolean
  moodCheckMode: MoodCheckMode
}

export function includesMoodCheck(mode: MoodCheckMode): boolean {
  return mode !== 'none'
}

/** Next step once WoT is satisfied or skipped */
export function stepAfterCheckin(
  panasDone: boolean,
  options: SessionStartOptions,
): SessionStartStep {
  if (includesMoodCheck(options.moodCheckMode) && !panasDone) {
    return 'benchmark-intro'
  }
  if (options.includeWarmup) return 'menu'
  return 'menu'
}

export function shouldSkipToCanvas(
  wot: WotSelection | null,
  panasDone: boolean,
  options: SessionStartOptions,
): boolean {
  const wotOk = !options.includeWotCheck || wot !== null
  const panasOk = !includesMoodCheck(options.moodCheckMode) || panasDone
  return wotOk && panasOk && !options.includeWarmup
}

export function resolveSessionStartStep(
  practiceDone: boolean,
  wot: WotSelection | null,
  panasDone: boolean,
  options: SessionStartOptions,
): SessionStartStep {
  if (practiceDone) return 'landing'
  if (options.includeWotCheck && wot === null) return 'checkin'
  return stepAfterCheckin(panasDone, options)
}
